export type CompanyProfileInput = {
  firstName: string;
  lastName: string;
  companyName: string;
};

export type CompanyProfileErrors = Partial<Record<keyof CompanyProfileInput, string>>;

export function validateCompanyProfile(input: CompanyProfileInput): CompanyProfileErrors {
  const errors: CompanyProfileErrors = {};
  if (!input.firstName.trim()) errors.firstName = 'Enter your first name';
  if (!input.lastName.trim()) errors.lastName = 'Enter your last name';
  if (!input.companyName.trim()) errors.companyName = 'Enter your company name';
  return errors;
}

export function companyProfileIsValid(input: CompanyProfileInput): boolean {
  return Object.keys(validateCompanyProfile(input)).length === 0;
}
